import { useController, useFormContext } from 'react-hook-form'
import clsx from 'clsx'

import getInputClasses from '@/shared/ui/Form/lib/input-classes'

const normalizeOptions = options =>
  Array.isArray(options)
    ? options.map(option =>
        typeof option === 'object'
          ? option
          : { label: String(option), value: option }
      )
    : []

const Select = ({
  name,
  control,
  options = [],
  placeholder,
  className = '',
  isClearable,
  required,
  rules,
  onChange: onChangeProp,
  ...rest
}) => {
  const {
    field: { value, onChange, ...field },
    fieldState: { invalid },
    formState: { errors }
  } = useController({ name, control, rules })

  const isInvalid = !!errors[name] || invalid
  const classes = getInputClasses(
    { prefix: 'form-select', className },
    isInvalid
  )
  const normalizedOptions = normalizeOptions(options)

  return (
    <select
      className={classes}
      value={value ?? ''}
      onChange={event => {
        // Update the RHF field first, then let the caller react (e.g. auto-submit
        // a filter form). Pulling onChange out of `...rest` keeps a caller-provided
        // handler from clobbering the field binding.
        onChange(event.target.value || null)
        onChangeProp?.(event)
      }}
      aria-invalid={isInvalid || undefined}
      {...field}
      {...rest}
    >
      {/* Sem opção vazia, o `<select>` nativo seleciona a primeira opção da
          lista sozinho — um campo obrigatório sem resposta nenhuma aparecia
          como já respondido com o primeiro item. `required` sozinho não
          bastava: ele só controla a validação HTML5, não se a opção vazia
          existe. */}
      {(placeholder || isClearable || required) && (
        <option value="">{placeholder || 'Selecione'}</option>
      )}
      {normalizedOptions.map(option => (
        <option key={`${option.value}`} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  )
}

const SelectContainer = ({ name, ...rest }) => {
  const { control } = useFormContext()
  return <Select name={name} control={control} {...rest} />
}

export default SelectContainer
